import React from 'react';
import moment from 'moment';
import { NameDateOption } from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/Options/Options.styles';
import BlockSelectField from '@common/components/FormElements/BlockSelectField';
import { useIsWindowWiderThan } from '@common/hooks/useIsWindowWiderThan';
import { gridTheme } from '@utils/grid';

const optionsForPerDateRange = (options, isMobile) => {
  return options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const labelDate = startDate === endDate ? startDate : `${startDate} - ${endDate}`;

    return {
      label: isMobile ? (
        `${labelDate}: ${option.name}`
      ) : (
        <NameDateOption>
          <strong>{option.name}</strong> {labelDate}
        </NameDateOption>
      ),
      value: index,
    };
  });
};

export const PerDateRange = ({ field, options }) => {
  return (
    <BlockSelectField
      onChange={(value) => {
        field.onChange(value);
      }}
      value={field.value}
      options={optionsForPerDateRange(options, !useIsWindowWiderThan(gridTheme.breakpoints.md))}
    />
  );
};
